import { FC } from 'react'
import type { HistogramData } from '@/api/chart/chart.service'
import { ResponsiveLine } from '@nivo/line'
import { HistTooltip } from './tooltips/HistTooltip'
import { makeTotalHistChartData } from '../../../utils/chart/makeTotalHistChartData'

export type SingleDomainHistogramProps = {
  histQueryResult: HistogramData
  schoolColors: { [id: string]: string }
  labels?: { [id: string]: string }
}

export const SingleDomainHistogram: FC<SingleDomainHistogramProps> = ({
  histQueryResult,
  schoolColors,
  labels,
}) => {
  const { xTicks, chartData } = makeTotalHistChartData(histQueryResult, schoolColors, labels)
  const minMax = xTicks.length >= 2 ? { min: xTicks.at(0), max: xTicks.at(-1) } : { min: 0, max: 0 }

  return (
    <ResponsiveLine
      data={chartData}
      margin={{ top: 50, right: 50, bottom: 50, left: 70 }}
      lineWidth={3}
      xScale={{
        type: 'linear',
        min: minMax.min,
        max: minMax.max,
      }}
      yScale={{
        type: 'linear',
        reverse: false,
      }}
      colors={(d) => d.color}
      axisBottom={{
        tickSize: 5,
        tickValues: xTicks,
        format: (value) => `${Math.round(Number(value))} g`,
      }}
      axisLeft={{
        tickSize: 5,
        format: (value) => `${value} %`,
      }}
      curve="monotoneX"
      pointSize={0}
      enableSlices="x"
      enableArea
      enableGridX={false}
      enableGridY={false}
      sliceTooltip={(p) => <HistTooltip item={p} labels={xTicks} />}
      legends={[
        {
          anchor: 'right',
          direction: 'column',
          justify: false,
          translateX: 70,
          translateY: 0,
          itemsSpacing: 4,
          itemDirection: 'left-to-right',
          itemWidth: 120,
          itemHeight: 16,
          symbolSize: 10,
          symbolShape: 'circle',
          toggleSerie: true,
        },
      ]}
    />
  )
}
